import { Panel } from "primereact/panel";
import FacultyFilter from "../../components/filters/FacultyFilter";
import SpecialityFilter from "../../components/filters/SpecialityFilter";
import EduFormFilter from "../../components/filters/EduFormFilter";
import TaxFilter from "../../components/filters/FeeFilter";
import CourseFilter from "../../components/filters/CourseYearFilter";
import OtherFilter from "../../components/filters/OtherFilter";
import {
  clearStudentFilters,
  getSelectedFaculties,
  getSelectedSpecialities,
  getSelectedDegrees,
  getSelectedEduForms,
  getStudentsFiltersCount,
  setSelectedFaculties,
  setSelectedDegrees,
  setSelectedEduForms,
  setSelectedSpecialities,
  setSelectedAcademicYears,
  getSelectedAcademicYears,
} from "../../services/students/studentsSlice";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { useAppDispatch } from "../../hooks/redux";
import AcademicYearFilter from "../../components/filters/AcademicYearFilter";
import StudentStatusFilter from "../../components/filters/StudentStatusFilter";
import EnrollmentDateFilter from "../../components/filters/EnrollmentDateFilter";
import DegreeFilter from "../../components/filters/DegreeFilter";

const ContextSidebar = (props: any) => {
  const studentFiltersCount = useSelector(getStudentsFiltersCount);
  const dispatch = useAppDispatch();

  const handleClearFilters = () => {
    dispatch(clearStudentFilters());
  };

  return (
    <Panel
      header="Филтриране на студенти"
      className="w-full mt-4 shadow-4"
      pt={{
        header: {
          className: "text-xl surface-ground font-light",
        },
      }}
      {...props}
    >
      {studentFiltersCount > 0 ? (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">{studentFiltersCount} активни филтъра.</p>
          <Button
            label="Изчисти филтрите"
            icon="pi pi-times"
            severity="danger"
            outlined
            size="small"
            className="w-50 mb-4"
            onClick={handleClearFilters}
          />
        </div>
      ) : (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">Няма активни филтри.</p>
          <div className="pi pi-sparkles pi-spin"></div>
        </div>
      )}
      <FacultyFilter getSelectedFaculties={getSelectedFaculties} setSelectedFaculties={setSelectedFaculties} />
      <AcademicYearFilter
        getSelectedAcademicYears={getSelectedAcademicYears}
        setSelectedAcademicYears={setSelectedAcademicYears}
      />
      <DegreeFilter getSelectedDegrees={getSelectedDegrees} setSelectedDegrees={setSelectedDegrees} />
      <SpecialityFilter
        getSelectedSpecialities={getSelectedSpecialities}
        setSelectedSpecialities={setSelectedSpecialities}
      />
      <EduFormFilter getSelectedEduForms={getSelectedEduForms} setSelectedEduForms={setSelectedEduForms} />
      <TaxFilter />
      <StudentStatusFilter />
      <CourseFilter />
      <EnrollmentDateFilter />
      <OtherFilter />
    </Panel>
  );
};

export default ContextSidebar;
